import { Xmark } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { Flex, Grid } from "styled-system/jsx";
import { Button, Text } from "@ttc3k/trekker";
import { CopyToClipboard } from "shared/components/molecules/CopyToClipboard/CopyToClilpboard";
import { useFormContext, useWatch } from "react-hook-form";
import { PersonContactInfoFormValues } from "../../../../usePersonContactInfoForm";
import { ControlledInput } from "shared/components/formControl";
import { useEffect } from "react";

export const EmailAddresses = () => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_CONTACT_INFO_MODAL.ADDITIONAL_CONTACT_INFO.LABELS",
  });

  const { control, formState, setValue } =
    useFormContext<PersonContactInfoFormValues>();
  const emails = useWatch({ control, name: "emails" });

  // Ensure there is at least one email address field visible
  useEffect(() => {
    if (emails?.length === 0) {
      setValue("emails", [""]);
    }
  }, [emails, setValue]);

  return (
    <Flex direction="column" gap="200">
      <Text visual="smallLabel">{t("EMAIL_ADDRESSES")}</Text>
      {/* Email inputs */}
      <Flex direction="column" gap="150">
        {emails?.map((email, index) => (
          <Flex direction="column" key={`email-${index}`}>
            {index === 0 && (
              <Text visual="smallTag" color="text.mid" mb="75">
                {t("EMAIL")}
              </Text>
            )}
            <Flex direction="column" gap="50">
              <Grid
                gridTemplateColumns="1fr auto auto"
                gridColumnGap="150"
                alignItems="start"
              >
                <ControlledInput
                  name={`emails.${index}`}
                  placeholder="example@example.com"
                  aria-label={`${t("EMAIL")} ${index + 1}`}
                />
                <CopyToClipboard
                  text={email}
                  iconOnly
                  iconSize="md"
                  iconCopyColor="icon.mid"
                  buttonProps={{
                    variant: "ghost",
                    visual: "primary",
                    borderRadius: "100",
                    px: "10px",
                    py: "10px",
                    mode: "light",
                    disabled:
                      formState.errors.emails?.[index] || !emails[index],
                    marginTop: "5px",
                    h: "38px",
                  }}
                  aria-label={`${t("COPY_EMAIL_ADDRESS")} ${index + 1}`}
                />
                <Button
                  variant="ghost"
                  mode="light"
                  Icon={Xmark}
                  onClick={() =>
                    setValue(
                      "emails",
                      emails.filter(
                        (_: string | undefined, i: number) => i !== index,
                      ),
                      { shouldDirty: true },
                    )
                  }
                  disabled={emails.length === 1 && index === 0}
                  marginTop="5px"
                  h="38px"
                  aria-label={`${t("DELETE_EMAIL_ADDRESS")} ${index + 1}`}
                />
              </Grid>
            </Flex>
          </Flex>
        ))}
        {/* Add email button */}
        <Button
          alignSelf="flex-start"
          visual="unstyled"
          size="sm"
          color={{
            base: "text.accent.blue.mid",
            hover: "text.accent.blue.dark",
            focusVisible: "text.accent.blue.dark",
          }}
          onClick={() =>
            setValue("emails", [...((emails ?? []) as string[]), ""], {
              shouldDirty: true,
            })
          }
          type="button"
        >
          {t("ADD_EMAIL_ADDRESS")}
        </Button>
      </Flex>
    </Flex>
  );
};
